import type {TGetGameDataResponse} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TPathPiecesOf, TRequestOf} from '@kapitalist/contract/endpoints/types'
import {mkGameId, type TFormError, type TGameData} from '@kapitalist/contract/types'
import {safelyOr} from '@kapitalist/utils/safely'
import {GetApi} from '~/api/client'
import gameDataMock, {
  gameDataMockAtTime,
} from '~/api/endpoints/game/GetGameData/mock'
import MockConfig from '~/api/mocks/config'

const endpoint = endpoints.gameplay.getGameData

type Params = TRequestOf<typeof endpoint>
type PathPieces = TPathPiecesOf<typeof endpoint>

export default class GetGameData extends GetApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  public static mockResponseWithMockConfig = (data?: {
    params?: Params
    pathPieces: PathPieces
  }): TGetGameDataResponse => {
    // TODO eventually configure the response here with MockConfig
    return {
      spectatorRequests: [],
      gameData: {
        ...gameDataMockAtTime(MockConfig.time),
        gameId: safelyOr(
          data?.pathPieces.maybeGameId,
          mkGameId,
          gameDataMock.gameId
        ),
      },
    }
  }

  mockDelay() {
    return 500
  }

  static alwaysFail: boolean = false

  protected mockRequestFailure(): TFormError | null {
    if (GetGameData.alwaysFail /* || getRandomInt(10) === 10 */) {
      // uncomment this out to test what happens when this api fails several times in a row
      // GetGameData.alwaysFail = true
      return {errors: {idk: ['Something went wrong']}}
    }

    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(
    params: Params,
    pathPieces: PathPieces
  ): TGetGameDataResponse {
    return GetGameData.mockResponseWithMockConfig({params, pathPieces})
  }

  protected transformResponse(r: TGetGameDataResponse): TGetGameDataResponse {
    return {
      ...r,
      gameData: transformGameData(r.gameData),
    }
  }

  public mocksRequireLogin() {
    return true
  }
}

export const transformGameData = (r: TGameData): TGameData => {
  // NB: was using this for some data transformation earlier, don't need it now
  // but other things call it which will be useful later if we need more transformations
  return r
}
